export default __webpack_public_path__ + "static/media/logo.d12168d0.png";